module.exports = __webpack_public_path__ + "static/media/Jaxani_Veg_Food_logo-01.2be5140b.png";